import React from 'react';
import { H } from './design-tokens';
import { typography } from '../theme';
import { Logo } from './logo';

interface HeaderBrandProps {
  environment?: 'alt';
}

export const HeaderBrand: React.FC<HeaderBrandProps> = ({ environment }) => {
  if (environment === 'alt') {
    return (
      <span
        style={{
          color: H.text,
          fontFamily: typography.fontFamily.alt,
          fontWeight: typography.fontWeight.bold,
          fontSize: typography.fontSize.xxl,
          whiteSpace: 'nowrap',
          userSelect: 'none',
          lineHeight: 1
        }}
      >
        Digital Trending Lab
      </span>
    );
  }
  return <Logo />;
};
